import React, { Component } from 'react';
import '../../static/css/common.css';
import { Nav,Row,Col} from "react-bootstrap";
import { Link, NavLink,withRouter } from "react-router-dom";
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap/dist/js/bootstrap.js';
import $ from 'jquery';
import menu from '../../static/images/menu.png';
import header_logo from '../../static/images/header_logo.jpg';
import phone_logo from '../../static/images/phoneLogo.png';
import fangzi from '../../static/images/fangzi.png';
import phoneicon from '../../static/images/phoneicon.png';
import navdata from "../home/navdata"
import {baiduTongJI} from "../../api/utils"

class Header extends Component {
  constructor(props) {
    super(props);
    this.state = {
    	navs: {},
	    mnavs:{},
	    mActiveIndex:0
    }
  }
  toogleClass = () => {
    $('.mainheader').toggleClass('mainheaderToo');
    $('.phoneHeader').toggle();
  }
  ShowSecond = (key) => {
    // let that = e.currentTarget.className
    // that = that.substring(0, 5);
    // $("." + that + " .phoneSec").toggle();
    // $("." + that).toggleClass('avtiveBg');
	  let item=navdata.find((item,index)=>item.navKey===key)
	  if (!item){
		  item={}
	  }
	  this.setState({mnavs:item})
  }

  // selectElement = () =>{
  //     $('#nb_invite_ok').click();
  // }

	mRenderMenu=()=>{
		// navs
	}
  notToo = (e) =>{
    e.stopPropagation();
  }
  componentDidMount() {
  	this.selectNav()
	  baiduTongJI()
  }
	selectNav=()=>{
  	$('.nav-item').hover((e)=>{
		  let key=e.currentTarget.dataset.nav
		  let item=navdata.find((item,index)=>item.navKey===key)
		  if (!item){
			  item={}
		  }
		  this.setState({navs:item})
	  })
		$('body').on('mouseleave','.menulist',()=>{
			this.setState({navs: {}})
		})
		$('.navpc').mouseleave(()=>{
			this.setState({navs: {}})
		})
	}
	gopath=(url)=>{
  	// console.log(this.props)
		if (url==='/usa' || url==='/uk'){
			window.open(url)
			return
		}
    this.props.history.push(url)
	}
	render() {
  	let {navs}=this.state
    return (
      <div className='headertops'>
        <div className='container headtop'>
          <div className='flex-between hetop'>
            <div className='flex-start'>
              <div>
                <Link to="/">
                  <img src={header_logo} alt="logo" className="header_logo img-fluid" />
                </Link>
              </div>

              {/*<div className='flex-start topfzi'>*/}
              {/*  <div className='topfziimg'><img src={fangzi} alt="logo" className="img-fluid" /></div>*/}
              {/*  <div>美英高端留学解决方案</div>*/}
              {/*</div>*/}
            </div>
	          {/*<div className='topxiaozi'>*/}
		        {/*  成君之美 鼎力相丞*/}
	          {/*</div>*/}
	          <div className={'header-weixin'}>
		          <img src={require('../../static/images/weixnlogo.png')} alt=""/>
		          <div className={'dig'}>
			          <ul className={'ul'}>
				          <li className={'li'}>
					          <img src={require('../../static/images/weixin-sh.jpg')} alt=""/>
					          <div>上海美丞留学</div>
				          </li>
				          <li className={'li'}>
					          <img src={require('../../static/images/weixin-nj.jpg')} alt=""/>
					          <div>南京美丞留学</div>
				          </li>
			          </ul>
		          </div>
	          </div>
            <div className='flex-start '>
              <div className={'phoneicon'}><img src={phoneicon} alt="logo" className="img-fluid" /></div>
              <div className={'zixunphone'}>
	              上海 021-63306793 <br/> 南京 025-83755169
              </div>
            </div>
          </div>
        </div>
        <div className="mainheader">
          <div className="menucont">
            <div className="container navpc">
              <Nav className="navbar navbar-expand-lg navbar-light menulistwrap">
                <Link className="navbar-brand" to="/">
                  <div className="phonelogo"><img src={phone_logo} alt="logo" className="img-fluid" /></div>
                </Link>
                <button onClick={this.toogleClass} className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                <img src={menu} alt='menu' />
                </button>
                <div className="collapse container navbar-collapse" id="navbarSupportedContent">
                  <Row className='headerrow'>
                    {/*<Col md={2}>*/}
                    {/*</Col>*/}
                    <Col md={12}>
                      <ul className="navbar-nav ">
	                      <li className="nav-item  dropdown">
		                      <div className="nav-link ">
			                      <div onClick={()=>{this.gopath('/')}}>
				                      首页
			                      </div>
		                      </div>
	                      </li>
                    <li className="nav-item  dropdown" data-nav={'usa'}>
                      <div className="nav-link ">
                        <div onClick={()=>{this.gopath('/usa')}}>
                          美国留学
                          </div>
                      </div>
                    </li>
                    <li className="nav-item dropdown drops" data-nav={'england'}>
                      <div className="nav-link">
                        <div onClick={()=>{this.gopath('/uk')}}>
                          英国留学
                           </div>
                      </div>
                    </li>
                    <li className="nav-item dropdown" data-nav={'canada'}>
                      <div className="nav-link">
                        <div onClick={()=>{this.gopath('/canada')}}>
                          加拿大留学
                          </div>
                      </div>
                      {/*<div className="dropdown-menu" aria-labelledby="navbarDropdownMenuLink">*/}
	                    {/*  /!*<Link className="dropdown-item" to="/">二级菜单</Link>*!/*/}
	                    {/*  /!*<Link className="dropdown-item" to="/">二级菜单</Link>*!/*/}
	                    {/*  /!*<Link className="dropdown-item" to="/">二级菜单</Link>*!/*/}
	                    {/*  /!*<Link className="dropdown-item" to="/">二级菜单</Link>*!/*/}
                      {/*</div>*/}
                    </li>
                    <li className="nav-item dropdown" data-nav={'europe'}>
                      <div className="nav-link">
                        <div onClick={()=>{this.gopath('/europe')}}>
                          欧洲留学
                          </div>
                      </div>
                    </li>
	                      <li className="nav-item dropdown" data-nav={'asia'}>
		                      <div className="nav-link">
			                      <div onClick={()=>this.gopath('/singapore')}>
				                      亚洲留学
			                      </div>
		                      </div>
	                      </li>
                    <li className="nav-item dropdown" data-nav={'australia'}>
                      <div className="nav-link" >
                        <div onClick={()=>{this.gopath('/australia')}}>
                          大洋洲留学
                          </div>
                      </div>
                    </li>
	                      <li className="nav-item dropdown">
		                      <div className="nav-link" >
			                      <div onClick={()=>{this.gopath('/aboutus')}}>
				                      关于我们
			                      </div>
		                      </div>
	                      </li>
                  </ul>

                    </Col>
                  </Row>
                </div>
	              {
		              navs.navKey?<div className={'menulist'}>
			              {
				              navs.data.length?navs.data.map((item,index)=>(
					              <div key={index} className={'menuitem'}>
						              <div className={'fenlei'}>{item.category}</div>
						              <div className={'menuitem2'}>
							              {
								              item.list.map((it,i)=>{
									              return <div className={'txt'} onClick={()=>{this.gopath(it.link)}} key={i}>{it.text}</div>
								              })
							              }
						              </div>
					              </div>
				              )):null
			              }
		              </div>:null
	              }
              </Nav>
            </div>
            <ul className="phoneHeader">
	            <li className="yiji5">
		            <div className="fistmenu" ><Link to="/">首页</Link></div>
	            </li>
              <li className="yiji0" onClick={()=>{this.setState({mActiveIndex:1})}}>
                <div className="fistmenu" ><a>美国</a></div>
	              {
		              this.state.mActiveIndex===1?<div className={'secondNav'}>
			              <div className="secondNavItem" ><Link className={'secondNavA'} to={'/usa'}>美本</Link></div>
			              <div className="secondNavItem" ><Link className={'secondNavA'} to={'/usa'}>美研</Link></div>
		              </div>:null
	              }
              </li>

              <li className="yiji2" onClick={()=>{this.gopath('/uk')}}>
                <div className="fistmenu"><a>英国留学</a></div>
              </li>
              <li className="yiji3" onClick={()=>this.gopath('/canada')}>
                <div className="fistmenu"><a >加拿大留学</a></div>
              </li>
              <li className="yiji4" onClick={()=>this.gopath('/europe')}>
                <div className="fistmenu" ><a>欧洲留学</a></div>
              </li>
	            <li className="yiji4" onClick={()=>{this.setState({mActiveIndex:5})}}>
		            <div className="fistmenu"><a>亚洲留学</a></div>
		            {
		            	this.state.mActiveIndex===5?<div className={'secondNav'}>
				            <div className="secondNavItem" onClick={()=>{this.gopath('/hongkong')}}><a className={'secondNavA'}>中国香港</a></div>
				            <div className="secondNavItem" onClick={()=>{this.gopath('/singapore')}}><a className={'secondNavA'}>新加坡</a></div>
				            <div className="secondNavItem" onClick={()=>{this.gopath('/japan')}}><a className={'secondNavA'}>日本</a></div>
				            <div className="secondNavItem" onClick={()=>{this.gopath('/korea')}}><a className={'secondNavA'}>韩国</a></div>
				            <div className="secondNavItem" onClick={()=>{this.gopath('/malaysia')}}><a className={'secondNavA'}>马来西亚</a></div>
			            </div>:null
		            }
	            </li>
	            <li className="yiji4" onClick={()=>{this.setState({mActiveIndex:6})}}>
		            <div className="fistmenu" ><a>大洋洲留学</a></div>
		            {
			            this.state.mActiveIndex===6?<div className={'secondNav'}>
				            <div className="secondNavItem" ><Link className={'secondNavA'} to={'/australia'}>澳大利亚</Link></div>
				            <div className="secondNavItem" ><Link className={'secondNavA'} to={'/newzealand'}>新西兰</Link></div>
			            </div>:null
		            }
	            </li>
              <li className="yiji4" >
                <div className="fistmenu" ><Link to="/aboutus">关于我们</Link></div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    )
  }
}

export default withRouter(Header)
